const colors = {
  primary500: '#0343A3',
  primary400: '#0057DA',
  primary300: '#00A3FF',
  primary200: '#dbf2ff',
  black: '#2D2D2D',
  gray: '#939393',
  lightgray: '#f3f3f3',
  white: '#FFFFFF',
};

export default colors;
